import { useNavigate } from "react-router-dom";
import BannerManager from "Components/AnnouncementBanner/BannerManager";
import { getProfileCompletionBannerMessage } from "Components/ProfileCompletionReminder/ProfileCompletionReminder";
import TrialEndsTodayModal from "Components/TrialStatus/TrialEndsTodayModal";
import useTrialStatus from "hooks/useTrialStatus";
import { TRIAL_BANNER_ID } from "Utils/trialStatus";

const AnnouncementSlot = ({
  user,
  enabled = true,
  showTrial = true,
  showProfileBanner = false,
}) => {
  const navigate = useNavigate();
  const trial = useTrialStatus(user, { enabled });
  const endsTodayModalOpen = enabled && showTrial && trial.showEndsTodayModal;

  if (!enabled) return null;

  const messages = [
    showTrial ? trial.bannerMessage : null,
    showProfileBanner
      ? getProfileCompletionBannerMessage(user, () => navigate("/profile/edit"))
      : null,
  ];

  const handleDismiss = (message) => {
    if (message.id === TRIAL_BANNER_ID) trial.dismissBanner();
  };

  return (
    <>
      <BannerManager messages={messages} onDismiss={handleDismiss} />
      <TrialEndsTodayModal
        open={endsTodayModalOpen}
        onClose={trial.markEndsTodayModalShown}
        onUpgrade={() => {
          trial.markEndsTodayModalShown();
          navigate("/subscriptions");
        }}
      />
    </>
  );
};

export default AnnouncementSlot;
